export const TKeyFooter = {
  FOOTER_TAGLINE: "FOOTER_TAGLINE",
  FOOTER_TOOLS: "FOOTER_TOOLS",
  FOOTER_RESOURCES: "FOOTER_RESOURCES",
  FOOTER_LEGAL: "FOOTER_LEGAL",
} as const;
